/**
 * @generated SignedSource<<541d470ea4c7912541f284886a12d09f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type liveArticleArticle$data = {
  readonly entityId: string;
  readonly entityUuid: string;
  readonly " $fragmentSpreads": FragmentRefs<"articleImageGalleryContent" | "contentLiveArticleArticle" | "globalCheckerContent" | "newsletterWidgetLiveArticleArticle">;
  readonly " $fragmentType": "liveArticleArticle";
};
export type liveArticleArticle$key = {
  readonly " $data"?: liveArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"liveArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "liveArticleArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityUuid",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleImageGalleryContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentLiveArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "globalCheckerContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "newsletterWidgetLiveArticleArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "787d343e587785457f51b27823f1cc72";

export default node;
